// src/v2/components/GDS/Modal/index.tsx

import React from 'react';
import { Modal } from 'pepsico-ds';
import type { IModalProps } from 'pepsico-ds/dist/lib/Organisms/Modal/Modal';
// import { ModalGlobalStyle } from './styles';

export interface ModalWrapperProps
  extends Omit<IModalProps, 'hideCloseButton'> {
  showBackButton?: boolean;
}

const ModalWrapper: React.FC<ModalWrapperProps> = ({
  children,
  showBackButton = false,
  ...rest
}) => {
  return (
    <>
      {/* <ModalGlobalStyle showBackButton={showBackButton} /> */}
      <Modal
        hideCloseButton={showBackButton}
        showAuxiliaryButton={false}
        showPrimaryButton={false}
        showSecondaryButton={false}
        showLink={false}
        showTertiaryButton={false}
        // showSlot={false}
        {...rest}
      >
        {children}
      </Modal>
    </>
  );
};

export default ModalWrapper;
